<div class="row">
    <div class="col-4 mx-auto my-auto text-center text-muted">{{menssage}}</div>
</div>